export default __webpack_public_path__ + "static/media/IconDefault.c2673b5c.svg";